import { BLACKLIST_API } from '../config/admin';

// Public — returns the current blacklist as a string[]
export const fetchBlacklist = async () => {
  try {
    const res = await fetch(BLACKLIST_API.get, { cache: 'no-store' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const json = await res.json();
    if (!json.success || !Array.isArray(json.data)) return [];
    return json.data.map((a) => String(a).toLowerCase());
  } catch (err) {
    console.error('fetchBlacklist failed:', err);
    return [];
  }
};

// Admin-only — adminAddress is the connected wallet (used server-side for auth)
export const addToBlacklist = async (adminAddress, targetAddress) => {
  const res = await fetch(BLACKLIST_API.add, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Api-Key': BLACKLIST_API.apiKey,
      'X-Admin-Address': (adminAddress || '').toLowerCase(),
    },
    body: JSON.stringify({ address: targetAddress }),
  });
  const json = await res.json().catch(() => ({ success: false, message: 'Invalid response' }));
  return json;
};

export const removeFromBlacklist = async (adminAddress, targetAddress) => {
  const res = await fetch(BLACKLIST_API.remove, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Api-Key': BLACKLIST_API.apiKey,
      'X-Admin-Address': (adminAddress || '').toLowerCase(),
    },
    body: JSON.stringify({ address: targetAddress }),
  });
  const json = await res.json().catch(() => ({ success: false, message: 'Invalid response' }));
  return json;
};
